import { render, staticRenderFns } from "./DiseasesCategorizedField.vue?vue&type=template&id=e5dc6996&scoped=true"
import script from "./DiseasesCategorizedField.vue?vue&type=script&lang=js"
export * from "./DiseasesCategorizedField.vue?vue&type=script&lang=js"
import style0 from "./DiseasesCategorizedField.vue?vue&type=style&index=0&id=e5dc6996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc6996",
  null
  
)

export default component.exports